import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import taskGroupsActions from '../../store/task-groups/action-creators/index';
import taskGroupsSelectors from '../../store/task-groups/selectors';
import CloseActionButton from '../common/CloseActionButton';
import EditActionButton from '../common/EditActionButton';
import FormattedProperty from '../common/FormattedProperty';
import ListActionSubheader from '../common/ListActionSubheader';
import TaskList from './tasks/TaskList';
import TaskGroupAdd from "./TaskGroupAdd";
import Modal from "../../../shared/ui/Modal";
import taskConfigActionCreators from "../../../admin-app/store/tasks-config/action-creators";

class TaskGroupDetail extends Component {
  constructor(props) {
    super(props);
    this.onAddTask = this.onAddTask.bind(this);
    this.onEditTaskGroup = this.onEditTaskGroup.bind(this);
    this.onClose = this.onClose.bind(this);
    this.openAddTaskGroup = this.openAddTaskGroup.bind(this);
    this.closeAddTaskGroup = this.closeAddTaskGroup.bind(this);

    this.state = {
      isAddingTaskGroup: false
    }
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (this.props.match.params.taskGroupGuid !== this.props.selectedGuid) {
      this.props.setSelectedTaskGroup(this.props.match.params.taskGroupGuid);
    }
  }

  // ----------------------
  // Handlers
  // ----------------------

  refreshTaskGroups() {
    if(this.props.userContext.hasScope('admin')) {
      this.props.fetchConfigTaskGroups();
    }
    this.props.loadTaskGroupContainer();
  }

  onAddTask() {
    const url = `${this.props.location.pathname}/add-task`;
    this.props.history.push(url);
  }

  openAddTaskGroup() {
    this.setState({
      isAddingTaskGroup: true
    })
  }

  closeAddTaskGroup() {
    this.setState({
      isAddingTaskGroup: false
    })
  }

  finishAddTaskGroup() {
    this.refreshTaskGroups()
    this.closeAddTaskGroup()
  }

  onClose() {
    if(this.props.userContext.hasScope('admin')) {
      const url = `/admin/task-groups`;
      this.props.history.push(url);
    } else {
      const url = `/task-groups`;
      this.props.history.push(url);
    }
  }

  onEditTask(taskGuid) {
    const url = `${this.props.location.pathname}/edit-task/${taskGuid}`;
    this.props.history.push(url);
  }

  onEditTaskGroup() {
    const url = `${this.props.location.pathname}/edit`;
    this.props.history.push(url);
  }

  onRemoveTask(taskGuid) {
    this.props.removeTask(this.props.selectedTaskGroup.taskGroupGuid, taskGuid);
    this.refreshTaskGroups()
  }

  // ----------------------
  // Computed
  // ----------------------

  get canEdit() {
    return this.props.selectedTaskGroup.status === 'draft';
  }

  get isLoading() {
    return this.props.isLoading || !this.props.selectedTaskGroup;
  }

  get subGroups() {
    try {
      return this.props.taskGroupMap[this.props.selectedTaskGroup.taskGroupGuid].subGroups || []
    } catch (ex) {
      return [];
    }
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        <Fragment>
          {!this.isLoading && (
            <Fragment>
              <div className="app-content-header">
                <h4 className="title">{this.props.selectedTaskGroup.name}</h4>
                <CloseActionButton onClose={this.onClose} />
              </div>
              <div className="app-content profile">
                <ListActionSubheader title="Details">
                  {this.canEdit && (
                    <EditActionButton
                      label="Details"
                      onEdit={this.onEditTaskGroup}
                    />
                  )}
                </ListActionSubheader>
                <div className="card profile-details">
                  <div className="profile-details-item">
                    <FormattedProperty
                      label="Name"
                      value={this.props.selectedTaskGroup.name}
                    />
                  </div>
                  <div className="profile-details-item formatted">
                    <FormattedProperty
                      label="Reference Material"
                      value={this.props.selectedTaskGroup.description}
                    />
                  </div>
                  <div className="profile-details-item">
                    <FormattedProperty
                      label="Submitter role"
                      value={this.props.selectedTaskGroup.flow ? this.props.selectedTaskGroup.flow.submitter : ''}
                    />
                  </div>
                  <div className="profile-details-item">
                    <FormattedProperty
                      label="Acknowledger role"
                      value={this.props.selectedTaskGroup.flow ? this.props.selectedTaskGroup.flow.acknowledger : ''}
                    />
                  </div>
                </div>
                <TaskList
                  canAddEdit={this.canEdit}
                  onAdd={this.onAddTask}
                  onAddTaskGroup={this.openAddTaskGroup}
                  onEdit={taskGuid => this.onEditTask(taskGuid)}
                  onRemove={taskGuid => this.onRemoveTask(taskGuid)}
                  onRefresh={() => this.refreshTaskGroups()}
                  tasks={this.props.selectedTaskGroup.tasks}
                  subGroups={this.subGroups}
                  taskGroup={this.props.selectedTaskGroup}
                />
              </div>
            </Fragment>
          )}
          <Modal
            isOpen={this.state.isAddingTaskGroup}
            title="Create Task Group"
            onClose={() => this.closeAddTaskGroup()}
          >
            {this.state.isAddingTaskGroup && <TaskGroupAdd
              initialValues={{flow: this.props.selectedTaskGroup.flow}}
              taskGroupGuid={this.props.selectedTaskGroup.taskGroupGuid}
              onFinish={() => this.finishAddTaskGroup()}
            />}
          </Modal>
        </Fragment>
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.taskGroups.isLoading.length > 0,
    selectedGuid: state.taskGroups.selectedGuid,
    selectedTaskGroup: taskGroupsSelectors.selectedTaskGroup(state),
    taskGroupMap: state.taskGroups.taskGroupMap2,
    userContext: state.common.userContext
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    removeTask: (taskGroupGuid, taskGuid) => {
      return dispatch(taskGroupsActions.removeTaskFromTaskGroup(taskGroupGuid, taskGuid));
    },
    setSelectedTaskGroup: (taskGroupGuid) => {
      return dispatch(taskGroupsActions.setSelectedTaskGroup(taskGroupGuid));
    },
    loadTaskGroupContainer: () => {
      return dispatch(taskGroupsActions.loadTaskGroupContainer());
    },
    fetchConfigTaskGroups: () =>
      dispatch(taskConfigActionCreators.fetchConfigTaskGroups()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TaskGroupDetail));
